import React, { useState, useEffect } from "react";
import {
  AdvancedMarker,
  InfoWindow,
  Map,
  useMap,
} from "@vis.gl/react-google-maps";
import { FaLocationCrosshairs } from "react-icons/fa6";
import styles from "./responsive-map.module.css";

const ResponsiveMap = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const map = useMap();

  const containerStyle = {
    width: "100%",
    aspectRatio: "16/9",
  };

  const defaultCenter = {
    lat: 4.254461044915742,
    lng: 117.89619170607662,
  };
  const infoWindowOffset = [0, -25];

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 509px)");
    const handleMediaChange = () => setIsSmallScreen(mediaQuery.matches);

    // Add listener
    handleMediaChange(); // Check initial value
    mediaQuery.addEventListener("change", handleMediaChange);

    // Cleanup listener on unmount
    return () => mediaQuery.removeEventListener("change", handleMediaChange);
  }, []);

  const handleResetMap = () => {
    if (map) {
      const adjustedCenter = {
        lat: defaultCenter.lat - (infoWindowOffset[1] / 100000) * 4,
        lng: defaultCenter.lng - (infoWindowOffset[0] / 100000) * 4,
      };
      map.setCenter(adjustedCenter);
      map.panTo(adjustedCenter);
    }
  };

  return (
    <div className={`${styles.mapContainer} boxShadow-md`}>
      <Map
        defaultCenter={defaultCenter}
        defaultZoom={16}
        style={containerStyle}
        gestureHandling={"greedy"}
        disableDefaultUI={true}
        mapId={process.env.REACT_APP_GOOGLE_MAP_ID}
      >
        <AdvancedMarker
          position={defaultCenter}
          clickable={false}
          onClick={() => {}}
        />
        <InfoWindow
          position={defaultCenter}
          pixelOffset={infoWindowOffset}
          headerDisabled={true}
        >
          <h2
            style={{
              fontSize: "0.875rem",
              marginBottom: "0.4rem",
              fontWeight: 600,
            }}
          >
            Borneo Royale Hotel
          </h2>
          {!isSmallScreen && (
            <p id="venue-address">
              Mile 1, Jalan Kuhara
              <br />
              91000 Tawau
              <br />
              Sabah
              <br />
              Malaysia
            </p>
          )}
          <a
            target="_blank"
            jstcache="6"
            href="https://maps.google.com/maps?ll=4.254627,117.896192&amp;z=19&amp;t=m&amp;hl=en-US&amp;gl=US&amp;mapclient=apiv3&amp;cid=11068515901177020423"
          >
            <span style={{ color: "#931b1c", fontWeight: 600 }}>
              View on Google Maps
            </span>
          </a>
        </InfoWindow>
      </Map>
      <div className={`${styles.resetBtn} boxShadow`} onClick={handleResetMap}>
        <FaLocationCrosshairs />
      </div>
    </div>
  );
};

export default ResponsiveMap;
